












































































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import { CatalogSession } from '@/Model/sessions/catalogTypes'
import Tag from '../../removeableTag/Tag.vue'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import SessionPriceTag from '@/components/familyPortal/sessionCard/SessionPriceTag.vue'
import BaseCard from '@/components/familyPortal/sessionCard/BaseCard.vue'
import { SubmitCartScholar } from '@/Model/checkout/cart/types'
import cart from '@/store/modules/checkout/cart/module'
import APP_CONST from '@/constants/AppConst'
import RemoveApplicationAlert from '@/popupcomponents/removeApplication/RemoveApplication.vue'
import { UpdateCartItemActionPayload } from '@/Model/checkout/cart/types'

@Component({
  components: {
    SessionPriceTag,
    BaseCard,
    Tag,
    RemoveApplicationAlert
  }
})
export default class SubmitCard extends Mixins(DeviceWidthCheckerMixin) {
  @Prop({ type: Boolean, default: true }) readonly disabled!: boolean
  @Prop({ type: Boolean }) readonly hasOnlinePayments!: boolean
  @Prop({ type: Boolean, default: true }) readonly removable!: boolean
  @Prop({ type: Object, required: true }) readonly session!: CatalogSession
  @Prop({ type: Number, required: true }) childrenSelection!: number
  @Prop({ type: Array, required: false }) scholars: SubmitCartScholar[] | undefined
  @PropSync('isAutomaticDiscountEnabled', { type: Boolean })
  isAutomaticDiscountEnabledSync!: boolean
  @PropSync('isPaymentPlanFlagEnabled', { type: Boolean }) isPaymentPlanFlagEnabledSync!: boolean

  readonly screenText = new ScreenText()
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES
  isApplicationRemovalAlert = false

  get childrenLabelText(): string {
    return this.screenText.getScreenText('CATALOG_SESSION_PARTICIPANTS_LABEL')
  }

  get noChildrenText(): string {
    return this.screenText.getScreenText('NO_CHILDREN_FOUND')
  }

  openRemoveApplicationAlert() {
    if (!this.removable || this.disabled) {
      return
    }
    this.isApplicationRemovalAlert = true
  }

  async onYesContinue() {
    this.isApplicationRemovalAlert = false
    await this.$nextTick()

    const updateCartItemPayload = {
      updateCartItemPayload: {
        cartId: cart.activeCartId,
        sessionId: this.session.sessionId,
        quantity: 0,
        scholarIds: []
      },
      session: this.session
    } as UpdateCartItemActionPayload

    await cart.updateCartItem(updateCartItemPayload)
    cart.fetchCartApplications()
  }

  onCancel() {
    this.isApplicationRemovalAlert = false
  }

  tagText(tag: SubmitCartScholar) {
    return `${tag.scholarFirstName} ${tag.scholarLastName}`
  }

  async handleScholarClick(tag: string) {
    if (!this.removable) {
      return
    }
    const interactedCartItem = cart.cartItems.find(
      (cartItem) =>
        cartItem.scholar &&
        cartItem.scholar.scholarFirstName + ' ' + cartItem.scholar.scholarLastName == tag &&
        cartItem.session.sessionId == this.session.sessionId
    )

    if (interactedCartItem) {
      await cart.removeSpecificCartItem(interactedCartItem)
      cart.fetchCartApplications()
    }
  }
}
